<template>
  <div id="login" class="login-container">
    <el-form
      ref="loginForm"
      :model="loginForm"
      class="loginForm"
      :rules="loginRules"
    >
      <div class="title-container">{{ $t("login.title") }}</div>

      <el-form-item prop="userEmail" class="login-item">
        <el-input
          size="mini"
          class="login-input"
          v-model="loginForm.userEmail"
          :placeholder="$t('login.email')"
        >
          <i slot="prefix" class="login-label el-icon-message"></i>
        </el-input>
      </el-form-item>

      <el-form-item prop="password" class="login-item">
        <el-input
          :type="show"
          size="mini"
          class="login-input"
          v-model="loginForm.password"
          :placeholder="$t('login.password')"
        >
          <i slot="prefix" class="login-label el-icon-lock"></i>
          <i
            slot="suffix"
            class="login-view el-icon-view"
            @click="showPass"
          ></i>
        </el-input>
      </el-form-item>
      <el-row class="button-area">
        <el-button
          v-preventReClick
          size="mini"
          class="login_button"
          @click="submitInfo"
          >{{ $t("button.submit") }}</el-button
        >
        <a :href="userLoginUrl">
          <el-button
            v-preventReClick
            size="mini"
            class="login_button"
            :title="$t('login.user.blur')"
            >{{ $t("login.user.title") }}</el-button
          >
        </a>
      </el-row>
      <el-row class="explain">
        This login panel is prepared for chair, you can click 'User' button.
      </el-row>
    </el-form>
    <el-dialog
      title="提示"
      :visible.sync="centerDialogVisible"
      :modal-append-to-body="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      width="30%"
      center
    >
      <span>请完善邮箱、手机号信息，用于接收系统消息</span>
      <span slot="footer" class="dialog-footer">
        <el-button
          v-preventReClick
          type="primary"
          @click="perfectInfo()"
          v-show="perfectOf"
          >完善信息</el-button
        >
        <el-button
          v-preventReClick
          type="success"
          @click="perfectOk()"
          v-show="!perfectOf"
          >已完善</el-button
        >
      </span>
    </el-dialog>

    <div style="clear: both"></div>
  </div>
</template>

<script>
import Md5 from "js-md5";
import chairMenuList from "../../static/chair-menu.json";
import orgMenuList from "../../static/user-menu.json";
export default {
  name: "Login",
  data() {
    return {
      centerDialogVisible: false, //无邮箱信息提示
      perfectOf: true,
      userLoginUrl: process.env.BASE_API + encodeURIComponent(window.location),
      show: "password",
      loginForm: {
        password: "",
        userEmail: "",
      },
      conferenceId: this.$route.params.co_id,
      loginRules: {
        userEmail: [
          {
            required: true,
            message: this.$t("login.rule.userEmail"),
            trigger: "blur",
          },
        ],
        password: [
          {
            required: true,
            message: this.$t("login.rule.password"),
            trigger: "blur",
          },
        ],
      },
    };
  },
  mounted: function () {
    console.log("login-登录页", this.conferenceId, this.$route);
    let conferenceId = this.conferenceId;
    if (this.$route.query.icode) {
      localStorage.setItem("invitationCode", this.$route.query.icode);
    } else {
      localStorage.setItem("invitationCode", "");
    }
    if (this.$route.query.sessionId) {
      localStorage.setItem("sessionId", this.$route.query.sessionId);
    } else {
      localStorage.setItem("sessionId", "");
    }
    if (conferenceId != null) {
      let token = this.$route.query.token;
      if (token != null) {
        this.verifyUser(conferenceId, token);
      } else {
        let admin = this.$route.query.admin;
        if (admin == null || admin !== "true") {
          /**
           * 20250707 更新
           * CAC2024/23/22/21都增加一个这样的提示，跳转到最新版地址CAC2025
           * 902	CAC2021
           * 907	CAC2022
           * 914	CAC2023
           * 923	CAC2024
           * 934	CAC2025
           */
          if (
            conferenceId === "902" ||
            conferenceId === "907" ||
            conferenceId === "914" ||
            conferenceId === "923"
          ) {
            // 获取并打印用户的浏览器语言
            console.log(navigator.language);
            // this.$t("login.loginMsg"),
            let coId = ''
            switch (conferenceId) {
              case '902':
                coId = '2021'
                break;
              case '907':
                coId = '2022'
                break;
              case '914':
                coId = '2023'
                break;
              case '923':
                coId = '2024'
                break;
            
              default:
                break;
            }
            this.$confirm(
              '<p>'+this.$t("login.loginMsg1",{year: coId})+'</p><p>'+this.$t("login.loginMsg2")+'</p>',
              this.$t("message.prompt"),
              {
                dangerouslyUseHTMLString: true,
                confirmButtonText: this.$t("login.jumpNow"),
                cancelButtonText: this.$t("login.jumpCancel"),
                type: "warning",
                closeOnClickModal:false
              }
            )
              .then(() => {
                const locUrl = window.location.href.split(
                  "/" + conferenceId + "/"
                );
                if (locUrl.length === 2) {
                  const tUrl =
                    process.env.BASE_API +
                    encodeURIComponent(locUrl[0] + "/934/" + locUrl[1]);
                  window.location.href = tUrl;
                }
              })
              .catch(() => {
                window.location.href = this.userLoginUrl;
              });
          } else {
            window.location.href = this.userLoginUrl;
          }
        }
      }
    }
    this.getIsShowCertificate();

    // this.userLoginUrl = process.env.BASE_API + encodeURIComponent(window.location)
  },
  methods: {
    // 跳转统一平台，完善信息
    perfectInfo() {
      // let url ='http://47.105.175.33:7921/profileCenter?token=tokenbda282b2-5683-4809-b384-d8f2103926ef'
      let reapplyUrl = process.env.VUE_APP_INFO_API + this.$route.query.token;
      console.log(reapplyUrl);
      this.perfectOf = !this.perfectOf;
      window.open(reapplyUrl, "_blank");
    },
    // 已完善，验证邮箱
    perfectOk() {
      this.perfectOf = !this.perfectOf;
      this.getCurrUser();
    },
    verifyUser(conferenceId, token) {
      console.log("执行verifyUser");
      this.$myaxios
        .post("verify/user", {
          conferenceId: conferenceId,
          token: token,
        })
        .then(
          function (response) {
            if (
              response.data.code === "0000" ||
              response.data.code === "1005"
            ) {
              console.log("执行verifyUser-2");
              // this.$cookies.set('JSESSIONID', response.data.entity.JSESSIONID)
              this.getCurrUser();
            }
          }.bind(this)
        )
        .catch(function (error) {
          console.log("执行verifyUser3", error);
        });
    },
    submitInfo: function (event) {
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          this.$myaxios
            .post("login", {
              password: Md5(this.loginForm.password),
              userEmail: this.loginForm.userEmail,
              conferenceId: this.conferenceId,
            })
            .then(
              function (response) {
                if (response.data.code === "0000") {
                  this.$cookies.set(
                    "JSESSIONID",
                    response.data.entity.JSESSIONID
                  );
                  this.getCurrUser();
                }
              }.bind(this)
            )
            .catch(function (error) {
              console.log(error);
            });
        }
      });
    },
    async getIsShowCertificate() {
      await this.$myaxios
        .post(
          "config/findByAttrCode1?attrCode=isShowCertificate&conferenceId=" +
            this.$route.params.co_id
        )
        .then(
          function (response) {
            if ((response.data.code = "0000")) {
              localStorage.setItem("isShowCertificate", response.data.entity);
            } else {
              localStorage.setItem("isShowCertificate", "0");
            }
          }.bind(this)
        )
        .catch(function (error) {
          console.log(error);
          localStorage.setItem("isShowCertificate", "0");
        });
    },
    getCurrUser: function () {
      if (localStorage.getItem("isShowCertificate") != "1") {
        this.getIsShowCertificate();
      }
      let self = this;
      this.$myaxios
        .post("curr/user", {})
        .then(
          function (response2) {
            let entity = response2.data.entity;
            console.log(
              "执行getCurrUser",
              entity.userEmail == "",
              entity.userEmail
            );
            // userMobile
            if (
              entity.userEmail == "" ||
              entity.userEmail == null ||
              entity.userMobile == "" ||
              entity.userMobile == null
            ) {
              console.log("执行getCurrUser-1", response2);
              this.centerDialogVisible = true;
            } else {
              console.log("执行getCurrUser-2");
              let roleList = entity.roleList;
              let user = {
                conferenceId: entity.conferenceId,
                conferenceName: entity.conferenceName,
                ifChair: entity.ifChair,
                ifCochair: entity.ifCochair,
                userId: entity.userId,
                userEmail: entity.userEmail,
                appellation: entity.appellation,
                currRole: entity.currRole,
                language: entity.language,
                submitPaperFlag: entity.submitPaperFlag,
              };
              let menuList = [];
              console.log("routers", chairMenuList, orgMenuList);
              if (entity.ifChair) {
                menuList = chairMenuList;
                user.currRole = "Chair";
              } else {
                for (let i in orgMenuList) {
                  if (orgMenuList[i].roleTitle === user.currRole) {
                    if (localStorage.getItem("isShowCertificate") == "1") {
                      menuList = orgMenuList[i].list;
                    } else {
                      //只有902会议可以看到审稿人证书页面，Cochair、Reviewer角色有权限
                      let menuList901 = JSON.parse(
                        JSON.stringify(orgMenuList[i].list)
                      );
                      for (let item of menuList901) {
                        item.details.forEach((value, index, array) => {
                          if (value.name == "Certificate") {
                            array.splice(index, 1);
                          }
                        });
                      }
                      menuList = menuList901;
                    }
                  }
                }
              }
              localStorage.setItem("menuData", JSON.stringify(menuList));
              localStorage.setItem("user", JSON.stringify(user));
              localStorage.setItem("roleList", JSON.stringify(roleList));
              localStorage.setItem("language", user.language);
              console.log(
                "entity.userEmail",
                entity.userEmail,
                entity.userEmail == ""
              );
              this.$router.push({ name: "paper" });
            }
            // this.searchRoles()
            // this.searchMenu()
          }.bind(this)
        )
        .catch(function (error) {
          console.log(error);
        });
    },
    resetInfo: function (event) {
      this.$refs["loginForm"].resetFields();
    },
    showPass() {
      if (this.show === "text") {
        this.show = "password";
      } else {
        this.show = "text";
      }
    },
  },
};
</script>

<style scoped>
.login-container {
  width: 100%;
  height: 100%;
  background-color: #2b3a4a;
}

.loginForm {
  width: 300px;
  height: 400px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: rgba(255, 255, 255, 0.1);
}

.title-container {
  font-size: 20px;
  color: #f0f0f0;
  margin: 50px;
  border-bottom: 1px solid #1f7a9f;
}

.login-item {
  width: 70%;
  margin-left: 15%;
}

.login-input {
  width: 100%;
  border: none;
  border-radius: 30px;
}

.login-label {
  width: 15%;
  float: left;
  font-size: 15px;
}
.el-input i {
  margin-right: 5px;
  margin-top: 12px;
  font-size: 15px;
}
.el-input .login-view:hover {
  color: #7d7e9c;
}

.button-area {
  margin-top: 40px;
  width: 70%;
  margin-left: 15%;
}

.login_button {
  background-color: #52709f;
  color: #f0f0f0;
  width: 100%;
  border: none;
  margin: 10px 0;
}
.explain {
  font-size: 10px;
  width: 70%;
  margin-left: 15%;
  color: #999;
}
</style>



// WEBPACK FOOTER //
// src/pages/login.vue